export const isZenDashOrigin = () => window.location.pathname.startsWith('/d/');
